import React, { SVGProps } from 'react';

const BubbleUpsellPattern = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="246"
    height="86"
    fill="none"
    viewBox="0 0 246 86"
    {...props}
  >
    <g opacity="0.1">
      <g clipPath="url(#clip0_642_74187)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M85.726-3.22h.001l.007.003a29.2 29.2 0 11-37.068 18.2l.01-.032A29.183 29.183 0 0185.727-3.22z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M67.257 46.396a22.164 22.164 0 01-14.331-16.73 21.719 21.719 0 01-.186-7.175c.157-1.1.395-2.188.713-3.253a4.661 4.661 0 01.784-1.751 3.056 3.056 0 013.038-1.128 3.152 3.152 0 012.497 3.778c-.117.525-.323 1.02-.45 1.54a16.19 16.19 0 00-.476 3.408c-.06 1.974.258 3.942.936 5.797a15.788 15.788 0 007.89 8.835c.527.265 1.073.491 1.634.676.827.241 1.524.8 1.939 1.554.346.628.465 1.355.336 2.06a3.154 3.154 0 01-3.66 2.548l-.12-.025a3.337 3.337 0 01-.54-.149"
        ></path>
      </g>
      <g clipPath="url(#clip1_642_74187)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M255.183 73.332h0l.007.002a27.272 27.272 0 017.579 49.817 27.274 27.274 0 01-30.27-1.375 27.272 27.272 0 01-10.315-28.492l.008-.03a27.254 27.254 0 0132.991-19.922z"
        ></path>
      </g>
      <g clipPath="url(#clip2_642_74187)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M235.666 6.777h.006a18.963 18.963 0 0115.837 24.67 18.962 18.962 0 01-36.875-8.04l.002-.023a18.953 18.953 0 0121.03-16.607z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M231.866 40.352a14.966 14.966 0 01-11.84-9.002 14.668 14.668 0 01-1.136-6.957c0-.437.092-.868.268-1.267a2.062 2.062 0 011.844-1.177 2.13 2.13 0 012.185 2.065c.001.024.002.049.001.073-.003.363-.068.718-.078 1.08-.026.776.032 1.553.171 2.317a10.455 10.455 0 001.443 3.693 10.662 10.662 0 006.465 4.707c.386.1.779.172 1.175.214.58.042 1.12.311 1.501.75a2.122 2.122 0 01-.729 3.323c-.254.116-.529.181-.808.19l-.084.002a2.244 2.244 0 01-.377-.022"
        ></path>
      </g>
      <g clipPath="url(#clip3_642_74187)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M155.666-18.223h.006a18.963 18.963 0 0115.837 24.67 18.962 18.962 0 01-36.875-8.04l.002-.023a18.953 18.953 0 0121.03-16.607z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M151.866 15.352a14.966 14.966 0 01-11.84-9.002 14.669 14.669 0 01-1.136-6.957c0-.437.092-.868.268-1.267a2.062 2.062 0 011.844-1.177 2.13 2.13 0 012.185 2.065c.001.024.002.049.001.073-.003.363-.068.718-.078 1.08-.026.776.032 1.553.171 2.317a10.455 10.455 0 001.443 3.693 10.662 10.662 0 006.465 4.707c.386.1.779.172 1.175.214.58.042 1.12.311 1.501.75a2.122 2.122 0 01-.729 3.323c-.254.116-.529.181-.808.19l-.084.002a2.244 2.244 0 01-.377-.022"
        ></path>
      </g>
      <g clipPath="url(#clip4_642_74187)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M26.666-18.223h.006A18.962 18.962 0 115.634-1.592l.002-.023a18.95 18.95 0 0121.03-16.607z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M22.866 15.352a14.965 14.965 0 01-11.84-9.002A14.665 14.665 0 019.882 1.64c-.053-.748-.05-1.5.008-2.248 0-.437.092-.868.268-1.267a2.062 2.062 0 011.844-1.177 2.128 2.128 0 012.186 2.138c-.003.363-.068.718-.078 1.08-.026.776.032 1.553.17 2.317a10.46 10.46 0 001.445 3.693 10.66 10.66 0 006.464 4.707c.386.1.779.172 1.175.214.58.042 1.12.311 1.501.75a2.128 2.128 0 01-1.537 3.514h-.084a2.238 2.238 0 01-.377-.02"
        ></path>
      </g>
      <g clipPath="url(#clip5_642_74187)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M196.041 33.822h.001l.009.004a36.277 36.277 0 11-39.261 59.352 36.283 36.283 0 01-8.047-39.499l.015-.038a36.258 36.258 0 0147.283-19.82z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M169.679 93.621a27.147 27.147 0 01-16.309-21.488 26.624 26.624 0 01.292-8.783 27.415 27.415 0 011.107-3.926 5.705 5.705 0 011.085-2.083 3.74 3.74 0 013.795-1.16 3.858 3.858 0 012.813 4.672c-.01.044-.021.086-.034.128-.181.633-.468 1.222-.662 1.85a19.794 19.794 0 00-.828 4.131c-.216 2.41.03 4.838.726 7.154a19.335 19.335 0 009.006 11.37c.625.363 1.277.679 1.949.945a3.987 3.987 0 012.257 2.04 3.8 3.8 0 01.262 2.543 3.853 3.853 0 01-3.152 2.91 3.86 3.86 0 01-1.505-.06l-.147-.04a4.083 4.083 0 01-.647-.22"
        ></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_642_74187">
        <path
          fill="#fff"
          d="M0 0H63.038V63.038H0z"
          transform="rotate(-161.15 53.324 24.251)"
        ></path>
      </clipPath>
      <clipPath id="clip1_642_74187">
        <path
          fill="#fff"
          d="M0 0H59.179V59.179H0z"
          transform="rotate(-166.15 143.394 51.397)"
        ></path>
      </clipPath>
      <clipPath id="clip2_642_74187">
        <path
          fill="#fff"
          d="M0 0H42.561V42.561H0z"
          transform="rotate(-173.323 127.502 17.257)"
        ></path>
      </clipPath>
      <clipPath id="clip3_642_74187">
        <path
          fill="#fff"
          d="M0 0H42.561V42.561H0z"
          transform="rotate(-173.323 86.773 7.09)"
        ></path>
      </clipPath>
      <clipPath id="clip4_642_74187">
        <path
          fill="#fff"
          d="M0 0H42.561V42.561H0z"
          transform="rotate(-173.323 22.273 10.853)"
        ></path>
      </clipPath>
      <clipPath id="clip5_642_74187">
        <path
          fill="#fff"
          d="M0 0H77.194V77.194H0z"
          transform="rotate(-157.766 113.295 38.881)"
        ></path>
      </clipPath>
    </defs>
  </svg>
);

export default BubbleUpsellPattern;
